import darkTheme from "../theme/dark";
import lightTheme from "../theme/light";

const THEMES: { [key: string]: any } = { dark: darkTheme, light: lightTheme };

const LOCAL_STORAGE_KEY = "sj-theme";

function getBrowserTheme() {
  const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
  return darkThemeMq.matches ? "dark" : "light";
}

function getThemeFromQuery() {
  const theme = new URL(window.location.href).searchParams.get("theme")?.trim();
  if (theme === "dark" || theme === "highContrastDarkTheme") {
    return "dark";
  }

  if (theme === "light" || theme === "highContrastLightTheme") {
    return "light";
  }

  return undefined;
}

function getThemeFromLocalStorage(): any {
  const theme = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  return theme != null ? theme : undefined;
}

export function setThemeToLocalStorage(v: any) {
  window.localStorage.setItem(LOCAL_STORAGE_KEY, v);
}

function getDefaultThemeId() {
  return (
    getThemeFromQuery() ??
    getThemeFromLocalStorage() ??
    getBrowserTheme() ??
    "dark"
  );
}

function getThemeStyles(theme: string) {
  return THEMES[theme];
}

export { getThemeStyles, getDefaultThemeId };
